import { FlashMessageType } from '@axilon-apps/libs-ui-constants'

export type FlashAlertVariant = 'default' | 'info' | 'success' | 'warning' | 'destructive'

const map: Record<FlashMessageType, FlashAlertVariant> = {
  [FlashMessageType.Success]: 'success',
  [FlashMessageType.Error]: 'destructive',
  [FlashMessageType.Info]: 'info',
  [FlashMessageType.Warning]: 'warning',
  [FlashMessageType.Plain]: 'default'
}

const getAlertVariantByMessageType = (type: FlashMessageType): FlashAlertVariant => {
  const variant = map[type]

  if (!variant) {
    return 'info'
  }

  return variant
}

export default getAlertVariantByMessageType
